import { Grid } from "@mui/material";
import styled from "@emotion/styled";

import { memo, useState } from "react";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";

import HistoryTimeline from "./HistoryTimeline";
import Mon5Template from "./monts/Monts5Template";
import HistoryTimeLineHeader from "./HistoryTimeLineHeader";
import usePropertyHelpTypeLocations from "../../../../../hooks/helps/usePropertyHelpTypeLocations";

const ProjectValidationTimeline = () => {
  const { isProject } = usePropertyHelpTypeLocations();

  const [selectedDescription, setSelectedDescription] = useState<{
    title: string;
    descriptions: string;
    month: string;
  } | null>(null);

  const handleDescriptionClick = (description: {
    title: string;
    descriptions: string;
    month: string;
  }) => {
    setSelectedDescription(description);
  };

  if (!isProject) {
    return <></>;
  }

  return (
    <Content container sx={{ marginTop: "3rem" }}>
      <HistoryTimeLineHeader />
      <HistoryTimeline onDescriptionClick={handleDescriptionClick} />

      {selectedDescription && (
        <DescriptionWrapper>
          <Header>
            <TextSimple
              color="white"
              size="title"
              weight="700"
              sx={{ marginBottom: "0.4rem" }}
            >
              Descripción del MES {selectedDescription?.month}
            </TextSimple>
          </Header>

          <DescriptionContainer>
            <TextSimple color="blue" size="sub-title" weight="700">
              {selectedDescription.title}
            </TextSimple>

            {selectedDescription.month != "5" && (
              <TextSimple
                color="blue"
                size="description"
                weight="500"
                sx={{ whiteSpace: "pre-line" }}
              >
                {selectedDescription.descriptions}
              </TextSimple>
            )}

            {selectedDescription.month == "5" && <Mon5Template />}
          </DescriptionContainer>
        </DescriptionWrapper>
      )}
    </Content>
  );
};

export default memo(ProjectValidationTimeline);

const Content = styled(Grid)``;

const DescriptionWrapper = styled("div")`
  display: flex;
  margin: 1rem 0rem;
  flex-direction: column;
  width: -webkit-fill-available;
  border-radius: 1rem;
  border: 1px solid #1a3668;
  z-index: 0;
`;

const Header = styled("div")`
  width: -webkit-fill-available;
  border: 1px solid #1a3668;
  background-color: #1a3668;
  padding: 15px 10px;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
`;

const DescriptionContainer = styled("div")`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
